import { createFileRoute } from '@tanstack/react-router';
import { ConfigurationListPage } from '../pages/configuration/configuration-list-page';

export const Route = createFileRoute('/configuration/')({
  component: ConfigurationListPage,
});
